export default __webpack_public_path__ + "static/media/Imagen_familia.0ba15d9c.png";